<tr>
    <th class="section-2b-header__requirement" rowspan="2" colspan="2">PCI DSS Requirement</th>
    <th class="section-2b-header__testing" rowspan="2">Expected Testing</th>
    <th class="section-2b-header__responses" colspan="5">
        Response *<br />
        <span class="normal-italic-text">(Check one response for each requirement)</span>
    </th>
</tr>
<tr class="section-2b-header__responses-row">
    <th>In Place</th>
    <th>In Place<br />with CCW</th>
    <th>Not<br />Applicable</th>
    <th>Not Tested</th>
    <th>Not in Place</th>
</tr>
